module.exports = __webpack_public_path__ + "img/cornea.6046445a.svg";